import React from 'react';
import { Link } from 'react-router-dom';
import NewsletterSignup from './NewsletterSignup';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-border mt-40">
      {/* Newsletter Section */}
      <div className="editorial-container border-b border-border">
        <NewsletterSignup />
      </div>
      
      <div className="editorial-container py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-16">
          {/* Brand */}
          <div>
            <Link to="/" className="inline-block mb-4">
              <h3 className="text-base font-bold editorial-serif uppercase tracking-tight">
                Cultural Revolution
              </h3>
            </Link>
            <p className="text-sm text-muted-foreground leading-relaxed">
              The system beneath independent culture.
            </p>
          </div>

          {/* Links */}
          <div>
            <ul className="space-y-3">
              <li>
                <Link to="/projects" className="text-xs uppercase tracking-widest text-muted-foreground hover:text-foreground">
                  Projects
                </Link>
              </li>
              <li>
                <Link to="/artists" className="text-xs uppercase tracking-widest text-muted-foreground hover:text-foreground">
                  Artists
                </Link>
              </li>
              <li>
                <Link to="/companies" className="text-xs uppercase tracking-widest text-muted-foreground hover:text-foreground">
                  Companies
                </Link>
              </li>
            </ul>
          </div>

          {/* About / Contact / Login */}
          <div>
            <ul className="space-y-3">
              <li>
                <Link 
                  to="/about" 
                  className="text-xs uppercase tracking-widest text-muted-foreground hover:text-foreground"
                >
                  About
                </Link>
              </li>
              <li>
                <a
                  href="mailto:dldagerman1@gmail.com"
                  className="text-xs uppercase tracking-widest text-muted-foreground hover:text-foreground"
                >
                  Contact
                </a>
              </li>
              <li>
                <Link 
                  to="/cms/login" 
                  className="text-xs uppercase tracking-widest text-muted-foreground hover:text-foreground"
                >
                  Login
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-border">
          <p className="text-xs text-muted-foreground uppercase tracking-widest">
            © {currentYear}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;